import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  width: 100vw;
  min-height: 85vh;
  position: relative;
  width: 100vw;
  max-width: 100vw;
  overflow: hidden;
  @media only screen and (min-width: 867px) {
  }
`;
